import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useDispatch } from "react-redux";
import { addToCart } from "../../../store/cartSlice";
import { addServiceToCart } from "../../../store/cartbodydataslice";
import styles from "./Tentpackages.module.css";
import { addtentpackagetocartapi } from "../../../Apiservices/Auth/servers/fetchCategoryEvents";
import AddToCartButton from "../../ServiceProvider/addtocartbutton";
import tentImage from '../../../assets/images/quickservices/tent.png';


const ShowTentPackageForUser = ({ packages: tentPackages, eventId, eventName }) => {
  const dispatch = useDispatch();
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [showPackageDialog, setShowPackageDialog] = useState(false);
  const [addingToCart, setAddingToCart] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedPackageDetail, setSelectedPackageDetail] = useState(null);
  const [showFullAddress, setShowFullAddress] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (tentPackages) {
      setLoading(false);
      // Set default selected package ID for each provider
      const defaultSelections = {};
      tentPackages.forEach(provider => {
        if (provider.tent_packages && provider.tent_packages.length > 0) {
          defaultSelections[provider.id] = provider.tent_packages[0]?.id;
        }
      });
      setSelectedPackageId(defaultSelections);
    }
  }, [tentPackages]);

  const handleAddToCart = async (tentPackage, provider) => {
    if (!eventId) {
      console.error("No event ID provided");
      alert("Please select an event first");
      return;
    }

    setAddingToCart(true);
    setIsProcessing(true);

    try {
      const apiData = {
        event_id: eventId,
        package_id: tentPackage.id,
      };

      const response = await addtentpackagetocartapi(apiData);

      if (response && response.success) {
        const cartItem = response.data;

        const cartData = {
          serviceType: "tenthouse",
          eventID: eventId,
          providerID: provider.id,
          service_id: null,
          cart_id: cartItem.id,
          price: parseFloat(tentPackage.regular_price) || 0,
          discountprice: parseFloat(tentPackage.offered_price) || 0,
          quantity: 1,
          discountvalidupto: tentPackage.offered_valid_till || null,
          is_checked_out: false,
          is_package: true,
          package_id: tentPackage.id
        };

        const cartbodyData = {
          eveId: eventId,
          eventname: eventName || "Event",
          type: 'tentHouseData',
          item: {
            id: cartItem.id,
            provider_id: provider.id,
            providername: `${provider.firstName || ''} ${provider.lastName || ''}`,
            package_id: tentPackage.id,
            package_name: tentPackage.package_name,
            regular_price: parseFloat(tentPackage.regular_price) || 0,
            offered_price: parseFloat(tentPackage.offered_price) || 0,
            offered_valid_till: tentPackage.offered_valid_till,
            people_capacity: tentPackage.people_capacity,
            description: tentPackage.description,
            package_items: tentPackage.package_items || [],
            recommendedEvents: tentPackage.recommendedEvents || [],
            total_amount: cartItem.total_amount || parseFloat(tentPackage.regular_price) || 0,
            balance_to_be_paid: cartItem.balance_to_be_paid || parseFloat(tentPackage.regular_price) || 0,
            is_checked_out: cartItem.is_checked_out || false,
            is_edit_allowed: cartItem.is_edit_allowed || true,
            paid_amount: cartItem.paid_amount || 0,
            is_cancel_in_progress: cartItem.is_cancel_in_progress || false,
            is_canceled: cartItem.is_canceled || false,
            refund_complete: cartItem.refund_complete || false,
            refund_in_pending: cartItem.refund_in_pending || false,
            refunded_amount: cartItem.refunded_amount || 0,
            is_package: true,
            cart_id: cartItem.cart_id || cartItem.cart?.id,
            services: (tentPackage.package_items || []).map(item => ({
              service_id: item.tent_house_service_id,
              service_name: item.tent_house_service?.service_name,
              quantity: item.item_qty || 1,
              price: 0,
            }))
          },
        };

        dispatch(addToCart(cartData));
        dispatch(addServiceToCart(cartbodyData));

        setShowPackageDialog(false);
        alert(`Added "${tentPackage.package_name}" to cart successfully!`);
        navigate('/cart');

      } else {
        const errorMessage = response?.message || "Failed to add package to cart";
        throw new Error(errorMessage);
      }

    } catch (error) {
      console.error("Error adding to cart:", error);
      if (error.message && error.message.includes("already have")) {
        alert(error.message);
      } else {
        alert("Failed to add package to cart. Please try again.");
      }
    } finally {
      setAddingToCart(false);
      setIsProcessing(false);
    }
  };

  const handlePackageSelect = (providerId, packageId) => {
    setSelectedPackageId(prev => ({
      ...prev,
      [providerId]: packageId
    }));
  };

  const handleViewDetails = (tentPackage, provider) => {
    setSelectedPackageDetail(tentPackage);
    setSelectedProvider(provider);
    setShowPackageDialog(true);
  };

  const toggleAddress = (providerId) => {
    setShowFullAddress(prev => ({
      ...prev,
      [providerId]: !prev[providerId]
    }));
  };

  const formatPrice = (price) => {
    if (!price) return "₹0";
    return `₹${parseFloat(price).toLocaleString('en-IN')}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "No expiry";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  // Rating component
  const RatingTag = ({ rating = 4.5 }) => (
    <div className={styles.rating_tag}>
      <i className="pi pi-star" style={{ fontSize: '12px', color: '#4caf50' }}></i>
      <span className={styles.rating_value}>{rating.toFixed(1)}</span>
    </div>
  );

  // Avatar component
  const Avatar = ({ name }) => (
    <div className={styles.dealer_avatar}>
      <img 
        src={tentImage} 
        alt={name}
        className={styles.avatar_image}
      />
    </div>
  );

  // TentHousePackage Component (similar to Flutter TentHosePackageComponent)
  const TentHousePackageComponent = ({ package: pkg, isSelected, onSelect, onViewDetails }) => {
    const hasDiscount = pkg.offered_price &&
      parseFloat(pkg.offered_price) < parseFloat(pkg.regular_price);

    return (
      <div 
        className={`${styles.package_component} ${isSelected ? styles.selected : ''}`}
        onClick={onSelect}
      >
        <div className={styles.package_component_content}>
          <div className={styles.package_info}>
            <div className={styles.package_radio}>
              <div className={`${styles.radio_circle} ${isSelected ? styles.radio_selected : ''}`}>
                {isSelected && <div className={styles.radio_inner}></div>}
              </div>
            </div>
            
            <div className={styles.package_details_compact}>
              <h4 className={styles.package_name_compact}>{pkg.package_name}</h4>
              
              <div className={styles.package_price_compact}>
                {hasDiscount ? (
                  <>
                    <span className={styles.regular_price_compact_strike}>
                      {formatPrice(pkg.regular_price)}
                    </span>
                    <span className={styles.offered_price_compact}>
                      {formatPrice(pkg.offered_price)}
                    </span>
                  </>
                ) : (
                  <span className={styles.regular_price_compact}>
                    {formatPrice(pkg.regular_price)}
                  </span>
                )}
              </div>
              
              {pkg.people_capacity && (
                <div className={styles.capacity_compact}>
                  <i className="pi pi-users" style={{ fontSize: '10px', marginRight: '4px' }}></i>
                  {pkg.people_capacity} people
                </div>
              )}
            </div>
          </div>
          
          <button 
            className={styles.view_details_btn_compact}
            onClick={(e) => {
              e.stopPropagation();
              onViewDetails();
            }}
          >
            View Details
          </button>
        </div>
      </div>
    );
  };

  // Provider Card Component (similar to Flutter TentHouseEventProviderCard)
  const ProviderCard = ({ provider }) => {
    const packages = provider.tent_packages || [];
    const currentSelectedId = selectedPackageId?.[provider.id] || packages[0]?.id;
    const isProcessingLocal = isProcessing && selectedProvider?.id === provider.id;

    const handleAddPackage = async () => {
      if (!currentSelectedId) {
        alert("Please select a package");
        return;
      }
      const selectedPkg = packages.find(p => p.id === currentSelectedId);
      if (selectedPkg) {
        await handleAddToCart(selectedPkg, provider);
      }
    };

    return (
      <div className={styles.provider_card}>
        {/* Dealer Basic Information */}
        <div className={styles.dealer_info}>
          <Avatar name={provider.firstName} />
          
          <div className={styles.dealer_details}>
            <div className={styles.rating_row}>
              <RatingTag rating={4.5} />
            </div>
            
            <h4 className={styles.dealer_name}>
              {provider.firstName} {provider.lastName}
            </h4>
            
            {provider.formattedAddress && (
              <div 
                className={styles.address_row}
                onClick={() => toggleAddress(provider.id)}
              >
                <span className={styles.address_text}>
                  {showFullAddress[provider.id] 
                    ? provider.formattedAddress 
                    : `${provider.formattedAddress.substring(0, 50)}...`}
                </span>
                <i className={`pi pi-chevron-${showFullAddress[provider.id] ? 'up' : 'down'}`} style={{ fontSize: '12px', color: '#999' }}></i>
              </div>
            )}
            
            {provider.distanceInMeter && (
              <div className={styles.distance}>
                {(provider.distanceInMeter / 1000).toFixed(1)} km
              </div>
            )}
          </div>
        </div>

        {/* Packages Section */}
        <div className={styles.packages_section}>
          <div className={styles.packages_header}>
            <span className={styles.packages_count}>
              ({packages.length}) {packages.length === 1 ? 'Package:' : 'Packages:'}
            </span>
          </div>
          
          <div className={styles.packages_list}>
            {packages.map((pkg) => (
              <TentHousePackageComponent
                key={pkg.id}
                package={pkg}
                isSelected={currentSelectedId === pkg.id}
                onSelect={() => handlePackageSelect(provider.id, pkg.id)}
                onViewDetails={() => handleViewDetails(pkg, provider)}
              />
            ))}
          </div>
          
          <AddToCartButton label={isProcessingLocal ? "Adding..." : "Add Package to Cart"} onClick={handleAddPackage} />
          {/* <button 
            className={`${styles.add_to_cart_btn} ${(!currentSelectedId || isProcessingLocal) ? styles.disabled : ''}`}
            onClick={handleAddPackage}
            disabled={!currentSelectedId || isProcessingLocal}
          >
            {isProcessingLocal ? "Adding..." : "Add Package to Cart"}
          </button> */}
        </div>
      </div>
    );
  };

  // Package Details Dialog
  const PackageDetailsDialog = () => {
    if (!selectedPackageDetail) return null;

    const hasDiscount = selectedPackageDetail.offered_price &&
      parseFloat(selectedPackageDetail.offered_price) < parseFloat(selectedPackageDetail.regular_price);

    return (
      <Dialog
        header="Package Details"
        visible={showPackageDialog}
        style={{ width: '90vw', maxWidth: '500px' }}
        onHide={() => {
          setShowPackageDialog(false);
          setSelectedPackageDetail(null);
          setSelectedProvider(null);
        }}
        footer={
          <div className={styles.dialog_footer}>
            <button
              className={styles.cancel_btn}
              onClick={() => setShowPackageDialog(false)}
            >
              Cancel
            </button>
            <button
              className={styles.add_btn}
              onClick={() => handleAddToCart(selectedPackageDetail, selectedProvider)}
              disabled={addingToCart}
            >
              {addingToCart ? "Adding..." : "Add to Cart"}
            </button>
          </div>
        }
      >
        <div className={styles.package_details_dialog}>
          <h3 className={styles.dialog_package_name}>{selectedPackageDetail.package_name}</h3>
          
          <div className={styles.dialog_price_section}>
            {hasDiscount ? (
              <>
                <span className={styles.dialog_regular_price_strike}>
                  {formatPrice(selectedPackageDetail.regular_price)}
                </span>
                <span className={styles.dialog_offered_price}>
                  {formatPrice(selectedPackageDetail.offered_price)}
                </span>
                {selectedPackageDetail.offered_valid_till && (
                  <div className={styles.dialog_valid_until}>
                    Valid until: {formatDate(selectedPackageDetail.offered_valid_till)}
                  </div>
                )}
              </>
            ) : (
              <span className={styles.dialog_regular_price}>
                {formatPrice(selectedPackageDetail.regular_price)}
              </span>
            )}
          </div>

          <div className={styles.dialog_details}>
            <div className={styles.dialog_detail_row}>
              <span className={styles.detail_label}>Capacity:</span>
              <span className={styles.detail_value}>{selectedPackageDetail.people_capacity} people</span>
            </div>

            {selectedPackageDetail.recommendedEvents && selectedPackageDetail.recommendedEvents.length > 0 && (
              <div className={styles.dialog_detail_row}>
                <span className={styles.detail_label}>Recommended for:</span>
                <span className={styles.detail_value}>
                  {selectedPackageDetail.recommendedEvents.map(e => e.name).join(', ')}
                </span>
              </div>
            )}
          </div>

          {selectedPackageDetail.description && (
            <div className={styles.dialog_description}>
              <h4>Description</h4>
              <p>{selectedPackageDetail.description}</p>
            </div>
          )}

          {selectedPackageDetail.package_items && selectedPackageDetail.package_items.length > 0 && (
            <div className={styles.dialog_included_items}>
              <h4>Package Includes</h4>
              <ul className={styles.items_list_dialog}>
                {selectedPackageDetail.package_items.map((item, index) => (
                  <li key={index}>
                    {item.tent_house_service?.service_name || `Item ${index + 1}`}
                    {item.item_qty > 1 && ` (x${item.item_qty})`}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Dialog>
    );
  };

  if (loading) {
    return (
      <div className={styles.loading_container}>
        <i className="pi pi-spin pi-spinner-dotted" style={{ fontSize: "2rem", color: "#0cc0df" }}></i>
      </div>
    );
  }

  const hasPackages = tentPackages && tentPackages.some(provider =>
    provider.tent_packages && provider.tent_packages.length > 0
  );

  if (!tentPackages || tentPackages.length === 0 || !hasPackages) {
    return (
      <div className={styles.no_packages}>
        <p>No tent packages available.</p>
      </div>
    );
  }

  return (
    <div className={styles.show_tent_packages}>
      <div className={styles.all_providers_header}>
        <h3>Choose from the package</h3>
        <p className={styles.providers_count}>
          Showing packages from {tentPackages.length} provider{tentPackages.length > 1 ? 's' : ''}
        </p>
      </div>

      <div className={styles.providers_grid}>
        {tentPackages.map((provider) => (
          <ProviderCard key={provider.id} provider={provider} />
        ))}
      </div>

      <PackageDetailsDialog />
    </div>
  );
};

export default ShowTentPackageForUser;